import { useParams, Link, Navigate } from "react-router-dom";
import { Check, AlertCircle, TrendingUp } from "lucide-react";
import { SECTORS } from "@/lib/constants";
import Seo from "@/components/Seo";
import CTABand from "@/components/sections/CTABand";

export default function SectorDetail() {
  const { slug } = useParams();
  const sec = SECTORS.find((s) => s.slug === slug);
  if (!sec) return <Navigate to="/secteurs" replace />;

  return (
    <div data-testid={`sector-detail-${slug}`}>
      <Seo
        title={`Solutions pour ${sec.title}`}
        description={`Site web, SEO local et automatisation IA pour ${sec.title.toLowerCase()} au Québec. ${sec.caseStudy}`}
        path={`/secteurs/${slug}`}
        image={sec.image}
      />
      <section className="relative bg-[#0B1F3A] text-white py-20 overflow-hidden">
        <img src={sec.image} alt={sec.title} className="absolute inset-0 w-full h-full object-cover opacity-25" />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0B1F3A] via-[#0B1F3A]/90 to-transparent" />
        <div className="relative mx-auto max-w-7xl px-6 md:px-10">
          <Link to="/secteurs" className="text-sm text-[#00B8D9] font-semibold hover:underline" data-testid="back-to-sectors">← Tous les secteurs</Link>
          <h1 className="font-heading font-black text-4xl sm:text-5xl lg:text-6xl tracking-tighter mt-4">Solutions pour {sec.title}</h1>
          <p className="mt-4 text-lg text-gray-200 max-w-2xl">{sec.caseStudy}</p>
        </div>
      </section>

      <section className="bg-[#F5F7FA] py-16">
        <div className="mx-auto max-w-6xl px-6 md:px-10 grid md:grid-cols-2 gap-6">
          <div className="bg-white rounded-2xl p-8 border border-gray-200">
            <div className="flex items-center gap-2 mb-4">
              <AlertCircle className="h-5 w-5 text-red-500" />
              <h2 className="font-heading font-bold text-xl text-[#0B1F3A]">Problèmes fréquents</h2>
            </div>
            <ul className="space-y-3">
              {sec.problems.map((p) => <li key={p} className="text-[#4B5563] flex gap-3"><span className="text-red-500 flex-shrink-0">✕</span>{p}</li>)}
            </ul>
          </div>

          <div className="bg-[#0B1F3A] text-white rounded-2xl p-8">
            <div className="flex items-center gap-2 mb-4">
              <Check className="h-5 w-5 text-[#00B8D9]" />
              <h2 className="font-heading font-bold text-xl">Nos solutions</h2>
            </div>
            <ul className="space-y-3">
              {sec.solutions.map((s) => <li key={s} className="flex gap-3"><Check className="h-5 w-5 text-[#00B8D9] flex-shrink-0 mt-0.5" />{s}</li>)}
            </ul>
          </div>
        </div>

        <div className="mx-auto max-w-6xl px-6 md:px-10 mt-6">
          <div className="bg-white rounded-2xl p-8 border border-gray-200">
            <div className="flex items-center gap-2 mb-4">
              <TrendingUp className="h-5 w-5 text-[#00B8D9]" />
              <h2 className="font-heading font-bold text-xl text-[#0B1F3A]">Bénéfices mesurables</h2>
            </div>
            <div className="grid sm:grid-cols-3 gap-4">
              {sec.benefits.map((b) => (
                <div key={b} className="bg-[#F5F7FA] rounded-xl p-5 border border-gray-200">
                  <div className="font-semibold text-[#0B1F3A]">{b}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <CTABand title={`Spécialiste du secteur ${sec.title.toLowerCase()}`} subtitle="Parlons de vos défis et opportunités spécifiques." />
    </div>
  );
}
